<app-header></app-header>



<div class="dashboard-container">
  <div class="row">
    <div class="col-md-12 col-lg-12 col-xs-12 col-sm-12">
      <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="row">
              <div class="col-md-6 col-lg-6 col-xs-6 col-sm-12 carousel-left-panel"
                style="background-color:#503794;padding: 8%;">
                <h2 class="slider-title">Lorem ipsum dolor</h2>
                <p class="slider-Subtitle">Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a
                  typeface without relying on meaningful content</p>
                <button *ngIf="!loginStatus" class="button register-btn" (click)="registerClick()"><span>REGISTER HERE
                  </span></button>
              </div>
              <div class="col-md-6 col-lg-6 col-xs-6 col-sm-12" style="background-color:#503794;">
                <img class="img-fluid" src="../assets/images/iStock-1297387958.png" alt="Peggy's Cove, Halifax, Canada"
                  width="100%
                  " height="350">
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="row">
              <div class="col-md-6 col-lg-6 col-xs-6 col-sm-12 carousel-left-panel"
                style="background-color:#503794;padding: 8%;">
                <h2 class="slider-title">Lorem ipsum dolor2</h2>
                <p class="slider-Subtitle">Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a
                  typeface without relying on meaningful content</p>
                <button *ngIf="!loginStatus" class="button register-btn" (click)="registerClick()"><span>REGISTER HERE
                  </span></button>
              </div>
              <div class="col-md-6 col-lg-6 col-xs-6 col-sm-12" style="background-color:#503794;">
                <img class="img-fluid" src="../assets/images/iStock-1297387958.png" alt="Peggy's Cove, Halifax, Canada"
                  width="100%
                  " height="350">
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="row">
              <div class="col-md-6 col-lg-6 col-xs-6 col-sm-12 carousel-left-panel"
                style="background-color:#503794;padding: 8%;">
                <h2 class="slider-title">Lorem ipsum dolor3</h2>
                <p class="slider-Subtitle">Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a
                  typeface without relying on meaningful content</p>
                <button *ngIf="!loginStatus" class="button register-btn" (click)="registerClick()"><span>REGISTER HERE
                  </span></button>
              </div>
              <div class="col-md-6 col-lg-6 col-xs-6 col-sm-12" style="background-color:#503794;">
                <img class="img-fluid" src="../assets/images/iStock-1297387958.png" alt="Peggy's Cove, Halifax, Canada"
                  width="100%
                  " height="350">
              </div>
            </div>
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
          data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
          data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </div>
  <div class="container-fluid d-flex count-container">
    <div class="row text-center count-section">
      <h2 class="second-title">Our Impact</h2>
      <div class="col" *ngFor="let item of cards">
        <div class="col-space">
          <div class="card-body">
            <p class="card-title count-style" [ngStyle]="{'color': item?.color ? item?.color : 'black' }">{{item?.count
              ? item?.count : 0}} +</p>
            <p class="card-text">{{item?.text ? item?.text : 0}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid d-flex bottom-section mt-5">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-xl-6 col-xs-12 col-sm-12 text-center">
        <img src="../assets/images/Group 10.png" class="img-fluid mb-3 program-img" alt="" style="width: 85%;height: 360px;">
      </div>
      <div class="col-lg-6 col-md-6 col-xl-6 col-xs-12 col-sm-12 d-flex" style="align-items:center;">
        <div class="row">
          <div class="col-12">
            <div class="vl ps-3">
              <p class="m-0">About the program</p>
              <h3>Lorem Ipsum</h3>
            </div>
          </div>
          <div class="col-12">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
              dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
              ea commodo consequat.
            </p>
          </div>
          <div class="col-12">
            <button type="button" class="btn login mb-3">GET IN TOUCH</button>
          </div>
        </div>
        <div class="row" style="width:85%;">

        </div>
      </div>
    </div>
  </div>
</div>
<div>
  <app-footer></app-footer>
</div>